import React from "react";
import Context from "../../../Context";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import SuperSelect from "../../Misc/SuperSelect";
import Select from "react-select";
import EssenceReferenceStorageEdit from "../../Essence/EssenceReferenceStorageEdit";
import FormLine from "../../Misc/FormLine";
import DocumentPicker from "../../Misc/DocumentPicker";
import ModelPicker from "../../Misc/ModelPicker";
import ElasticInput from "../../Misc/ElasticInput";

export default class Order extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      item: {},
      lines: [],
      models: {},
      measure: [],
      currency: [],
      rowsExpanded: [],

      modelPickIdx: false,
      modelPickShow: false,
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
    this.renderButtons();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.orderId !== this.props.orderId) {
      this.load();
    }
    this.renderButtons();
  }

  onParentChange = async (id, parent) => {
    if (parent) {
      if (parent.classcode === "request") {
        let askResult = await this.context.ask(
          "Заполнить содержимое Акта из выбранного в качестве основания документа?"
        );
        if (askResult.value) {
          this.setState({ pending: true });
          let lines = [];
          let parentLines = await this.context.api.qa("/request/item/list", {
            filter: { documentid: id },
            orderby: ["itemid ASC"],
          });
          let neededModelsIDs = [];
          parentLines.forEach((line) => {
            if (line) {
              lines.push({
                modelid: line.modelid,
                measureid: line.measureid,
                volume: line.volume,
              });
              neededModelsIDs.push(line.modelid);
            }
          });
          await this.loadNeededModels(neededModelsIDs);
          this.setState({ lines, pending: false });
        }
      }
    }

    this.setState((state) => {
      let { item } = state;
      item.parent = id;
      return { item };
    });
  };

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  onLineChange = (idx, key, value) => {
    let { lines } = this.state;
    lines[idx][key] = value;
    this.setState({ lines });
  };

  onCreateModel = async (model) => {
    this.setState(
      (state) => {
        let { models } = state;
        models[model.id] = { label: model.label };
        return { models };
      },
      () => this.onLineChange(this.state.modelPickIdx, "modelid", model.id)
    );
  };

  getModelLabel = (id, defaultLabel = "") => {
    let result = defaultLabel;
    if (this.state.models[id]) {
      result = `${this.state.models[id].label}`;
    }
    return result;
  };

  onModelPickOpen = (idx) => {
    this.setState({ modelPickShow: true, modelPickIdx: idx });
  };

  onModelPickClose = () => {
    this.setState({ modelPickShow: false });
  };

  onModelPick = (model) => {
    this.setState(
      ({ models }) => {
        models[model.id] = model;
        return models;
      },
      () => this.onLineChange(this.state.modelPickIdx, "modelid", model.id)
    );
  };

  loadReferences = async () => {
    this.setState({ pending: true });
    let models = {};
    let measure = await this.context.api.qrc("/measure/list");
    let currency = await this.context.api.qrc("/currency/list");
    this.setState({ pending: false, models, measure, currency });
  };

  rowAdd = (idx) => {
    let { lines } = this.state;
    let index = idx || lines.length;
    lines.splice(index, 0, {});
    this.setState({ lines });
  };

  rowRemove = (idx) => {
    let { lines } = this.state;
    lines.splice(idx, 1);
    this.setState({ lines });
  };

  rowToggle = (idx) => {
    let { lines } = this.state;
    lines[idx].expanded = !lines[idx].expanded;
    this.setState({ lines });
  };

  load = async () => {
    const { orderId } = this.props;
    this.setState({ pending: true, notFound: false });
    if (orderId && orderId !== "add") {
      let item = await this.context.api.q("/order/get", { id: orderId });
      if (!item) {
        this.setState({ notFound: true });
      } else {
        let linesResult = await this.context.api.qa("/order/item/list", {
          filter: { documentid: orderId },
          orderby: ["itemid ASC"],
        });

        let lines = (linesResult || []).map((line) => {
          if (line.description) {
            line.expanded = true;
          }
          return line;
        });

        this.setState({ item, lines: lines || [] });
      }
    } else {
      await this.loadAppended();
      this.setState({ item: {} });
    }
    this.setState({ pending: false });
    this.context.force();
  };

  loadAppended = async () => {
    let searchParams = new URLSearchParams(
      this.props.location.search.substr(1)
    );
    let append = searchParams.get("append");
    if (append) {
      let appendItems = append.split(",");
      await this.loadNeededModels(appendItems);
      this.setState({
        lines: appendItems.map((modelid) => {
          return { modelid };
        }),
      });
    }
  };

  loadNeededModels = async (id = []) => {
    if (!id?.length) return;
    let appendQuery = await this.context.api.qo("/model/list", {
      fields: ["id", "label", "code", "subcode"],
      search: [{ field: "id", valarr: id }],
    });
    this.setState(({ models }) => {
      return { models: Object.assign(models, appendQuery) };
    });
  };

  save = async () => {
    let orderId = null;
    if (this.props.orderId && this.props.orderId !== "add") {
      orderId = this.props.orderId;
    }

    const { item } = this.state;
    this.setState({ pending: true });
    let saveData = {
      id: orderId,
      storage: item.storage,
      description: item.description,
      parent: item.parent,
    };
    let result = await this.context.api.q("/order/set", saveData);

    if (result !== false) {
      let items = [];
      let { lines } = this.state;
      lines.forEach((line) => {
        items.push({
          modelid: line.modelid,
          measureid: line.measureid,
          currencyid: line.currencyid,
          volume: line.volume,
          description: line.description,
          price: line.price,
        });
      });

      let itemsResult = await this.context.api.q("/order/item", {
        items,
        document: result.id,
      });
      if (itemsResult !== false) {
        this.context.toast("Изменения сохранены", "success");
      } else {
        this.context.toast("Не удалось сохранить изменения", "error");
      }

      if (this.props.orderId === "add") {
        this.setState({ pending: false });
        this.context.redirect(`/order/${result.id}`);
      } else {
        this.load();
      }
    } else {
      this.setState({ pending: false });
      this.context.toast("Не удалось сохранить изменения", "error");
    }
  };

  new = () => {
    this.setState({ lines: [] });
    this.context.redirect("/order/add");
  };

  open = () => {
    const { orderId } = this.props;
    if (orderId && orderId !== "add") {
      this.context.redirect(`/workdoc/any/any/${orderId}`);
    } else {
      this.context.redirect("/workdoc/");
    }
  };

  renderButtons = () => {
    this.context.actionsSet(
      <>
        <button
          title="Новый"
          onClick={this.new}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-file-o"></i>
        </button>
        <button
          title="Сохранить"
          onClick={this.save}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-save"></i>
        </button>
        <button
          title="Открыть"
          onClick={this.open}
          className={`btn btn-icon btn-light mr-2`}
        >
          <i className="fa fa-folder-open-o"></i>
        </button>
      </>
    );
  };

  render() {
    const { item, notFound, pending, lines } = this.state;
    const { orderId } = this.props;
    let title = orderId === "add" ? "Новый акт приема" : item.label;

    if (notFound) {
      title = "Документ не найден";
      return (
        <div className="container">
          <CrumbsProvider title={title} link="/order/" />
          <DefaultNotFound />
        </div>
      );
    }

    return (
      <>
        <ModelPicker
          onModelPick={this.onModelPick}
          onClose={this.onModelPickClose}
          onCreate={this.onCreateModel}
          show={this.state.modelPickShow}
          allowCreate
          keepModal
        />
        <CrumbsProvider title={title} link={`/order/${item.id}/`} />
        <div className="container h-100">
          <div className="row  h-100">
            <div className="col">
              <div className="card card-custom card-stretch">
                <Blocker on={pending}>
                  <div className="card-body px-5 py-5">
                    <div className="dochat">
                      <div className="flex-grow-1">
                        <div className="row">
                          <div className="col-6">
                            <FormLine label="Место хранения:">
                              <SuperSelect
                                defaultValue={item.storage}
                                onChange={(value) =>
                                  this.onChange("storage", value)
                                }
                                onSingleItem={(item) =>
                                  this.onChange("storage", item.value)
                                }
                                essence="storage"
                                placeholder="Выберите место хранения..."
                                nameField="name"
                                idField="id"
                                reference={{
                                  title: "Места хранения",
                                  essence: "storage",
                                  showDescription: true,
                                  showType: true,
                                  itemEditor: (itemEditorProps) => (
                                    <EssenceReferenceStorageEdit
                                      {...itemEditorProps}
                                    />
                                  ),
                                }}
                              />
                            </FormLine>
                          </div>
                          <div className="col-6">
                            <FormLine label="Основание:">
                              <DocumentPicker
                                classes={[
                                  "workdoc",
                                  "request",
                                  "fda",
                                  "troubleshooting",
                                  "cancellation",
                                ]}
                                states={["disabled"]}
                                defaultValue={item.parent}
                                onChange={(id, parent) =>
                                  this.onParentChange(id, parent)
                                }
                              />
                            </FormLine>
                          </div>
                          <div className="col-12 mt-3">
                            <FormLine label="Комментарий:">
                              <input
                                type="text"
                                value={item.description || ""}
                                onChange={(e) =>
                                  this.onChange("description", e.target.value)
                                }
                                className="form-control"
                              />
                            </FormLine>
                          </div>
                        </div>
                      </div>

                      {item.id && (
                        <div className="d-flex align-items-center ml-3">
                          <EssenceStateLabel
                            onAfterStateChanged={(c) => {
                              if (c === "enabled") {
                                this.open();
                              }
                            }}
                            stateCode={item.statetypecode}
                            stateLabel={item.statelabel}
                            essence="order"
                            id={item.id}
                          />
                          <EssenceActionsDropdown
                            essence={"order"}
                            key={item.id}
                            id={item.id}
                            label={item.label}
                            onFinish={this.load}
                          />
                        </div>
                      )}
                    </div>
                    <table className="table">
                      <thead>
                        <tr>
                          <th width="40%">
                            <i
                              title="Добавить строку"
                              onClick={() => this.rowAdd()}
                              className="fa fa-plus cursor-pointer text-hover-primary mr-2"
                            ></i>
                            Наименование
                          </th>
                          <th>Кол-во</th>
                          <th width="15%">Eд. изм.</th>
                          <th>Цена</th>
                          <th width="17%">Валюта</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lines.map((item, idx) => {
                          let line = item || {};

                          return (
                            <React.Fragment key={idx}>
                              <tr>
                                <td>
                                  <div className="input-group">
                                    <input
                                      readOnly
                                      type="text"
                                      className="form-control"
                                      placeholder="ЗИП"
                                      value={this.getModelLabel(
                                        line.modelid,
                                        line?.model?.name
                                      )}
                                      onDoubleClick={() =>
                                        this.onModelPickOpen(idx)
                                      }
                                    />
                                    <div className="input-group-append">
                                      <button
                                        title="Выбрать"
                                        className="btn btn-icon border"
                                        type="button"
                                        onClick={() =>
                                          this.onModelPickOpen(idx)
                                        }
                                      >
                                        <i className="fa icon-md text-muted fa-navicon"></i>
                                      </button>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <input
                                    className="form-control"
                                    value={item.volume || ""}
                                    size={3}
                                    type="number"
                                    onChange={(e) =>
                                      this.onLineChange(
                                        idx,
                                        "volume",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <Select
                                    value={this.context.api.getReferenceValue(
                                      line.measureid,
                                      this.state.measure
                                    )}
                                    onChange={(result) =>
                                      this.onLineChange(
                                        idx,
                                        "measureid",
                                        result.value
                                      )
                                    }
                                    className="from-control react-select"
                                    classNamePrefix="react-select-inner"
                                    options={this.state.measure}
                                    placeholder="..."
                                    noOptionsMessage={({ inputValue }) =>
                                      `Ничего не найдено по запросу ${inputValue}`
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    className="form-control"
                                    value={item.price || ""}
                                    size={3}
                                    type="number"
                                    onChange={(e) =>
                                      this.onLineChange(
                                        idx,
                                        "price",
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                      <Select
                                        value={this.context.api.getReferenceValue(
                                          line.currencyid,
                                          this.state.currency
                                        )}
                                        onChange={(result) =>
                                          this.onLineChange(
                                            idx,
                                            "currencyid",
                                            result.value
                                          )
                                        }
                                        className="from-control react-select"
                                        classNamePrefix="react-select-inner"
                                        options={this.state.currency}
                                        placeholder="..."
                                        noOptionsMessage={({ inputValue }) =>
                                          `Ничего не найдено по запросу ${inputValue}`
                                        }
                                      />
                                    </div>
                                    <div className="ml-3 text-nowrap">
                                      <i
                                        title="Удалить строку"
                                        onClick={() => this.rowRemove(idx)}
                                        className="fa fa-times cursor-pointer text-hover-danger "
                                      ></i>
                                      <i
                                        title="Добавить строку ниже"
                                        onClick={() => this.rowAdd(idx + 1)}
                                        className="fa fa-plus cursor-pointer text-hover-primary ml-2"
                                      ></i>
                                      <i
                                        title="Комментарий"
                                        onClick={() => this.rowToggle(idx)}
                                        className={`fa ${
                                          item.expanded
                                            ? "fa-chevron-up"
                                            : "fa-chevron-down"
                                        } cursor-pointer text-hover-primary ml-2`}
                                      ></i>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                              {item.expanded && (
                                <tr>
                                  <td colSpan={15}>
                                    <ElasticInput
                                      rows={1}
                                      value={line.description || ""}
                                      onChange={(e) =>
                                        this.onLineChange(
                                          idx,
                                          "description",
                                          e.target.value
                                        )
                                      }
                                      className="form-control"
                                      placeholder="Комментрий..."
                                    />
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Blocker>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
